import { useCallback, useEffect, useState } from 'react';
import {
  fetchBookById,
  fetchCatalog,
  fetchFeaturedBooks,
  fetchRelatedBooks
} from '../services/catalogApi';

export const useCatalog = (filters) => {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadBooks = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchCatalog(filters);
      setBooks(data);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    loadBooks();
  }, [loadBooks]);

  return { books, loading, reload: loadBooks };
};

export const useBookDetail = (id) => {
  const [book, setBook] = useState(null);
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const run = async () => {
      if (!id) return;
      setLoading(true);
      try {
        const [bookData, relatedData] = await Promise.all([
          fetchBookById(id),
          fetchRelatedBooks(id)
        ]);
        if (!mounted) return;
        setBook(bookData);
        setRelated(relatedData);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    run();
    return () => {
      mounted = false;
    };
  }, [id]);

  return { book, related, loading };
};

export const useFeatured = () => {
  const [featured, setFeatured] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const run = async () => {
      setLoading(true);
      try {
        const data = await fetchFeaturedBooks();
        if (mounted) setFeatured(data);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    run();
    return () => {
      mounted = false;
    };
  }, []);

  return { featured, loading };
};
